import { createAction } from 'redux-actions';

export const setIsEmailMapped = createAction<boolean>('SET_IS_EMAIL_MAPPED');
